/* eslint-disable max-len */
import React, { useState } from "react"
import DropDownComponent from './Dropdown';

const VoucherTypeDropdown = ({selectedFilter, handleSelectObject, searchParams}) => {
    const [selectedVocherType, setSelectedVocherType] = useState(searchParams.get('entry_type') !== null ? searchParams.get('entry_type') : '')
    const vocherTypeOptions  = [{ name: 'Contra' }, { name: 'Payment' }, { name: 'Receipt' }, { name: 'Journal' }, { name: 'RTE' }, { name: 'Scholarship' }]
    const [isMainDropdownOpen, setIsMainDropdownOpen] = useState(searchParams.get('entry_type') !== null ? false : true);

    /**
     * The `handleOnchangeInput` function updates the selected voucher type and triggers a callback
     * function based on the input ID.
     */
    const handleOnchangeInput = (id, item, index) => {
        if(id === 'Entry Type'){
            setSelectedVocherType(item.name)
            handleSelectObject(item.name, '', selectedFilter)
        }
    }

    return (
        <div>
            <DropDownComponent
                dropDownName={"Entry Type"}
                id={"Entry Type"}
                test_id={"Entry Type"} 
                divClassName={`slct-inpt-fld-div`}
                value={selectedVocherType}
                placeHolder={"Select Type"}
                buttonDisabled={false}
                options={vocherTypeOptions}
                handleOnchangeInput={handleOnchangeInput}
                tooltip={true}
                searchParams={searchParams}
                setisOpen={setIsMainDropdownOpen}
                isOpen={isMainDropdownOpen}
            />
        </div>
    )
} 

export default VoucherTypeDropdown;